import { MS_API_BACKEND_URL } from "../settings";
import { api } from "./api";

class DistributionCenterService {
  constructor() {
    this.url = MS_API_BACKEND_URL;
  }

  async getDistributionCenterByUser() {
    const url = `${this.url}/api/distribution-center/v1/distribution-centers/me`;
    const response = await api.get(url);
    return response.data;
  }

  async getDistributionCenterById(distributionCenterId) {
    const url = `${this.url}/api/distribution-center/v1/distribution-centers/${distributionCenterId}`;
    const response = await api.get(url);
    return response.data;
  }

  async getAllDistributionCenters() {
    const url = `${this.url}/api/distribution-center/v1/distribution-centers`;
    const response = await api.get(url);
    return response.data;
  }

  async getDistributionCentersByUser(params) {
    const url = `${this.url}/api/distribution-center/v1/distribution-centers/user`;
    const response = await api.get(url, { params });
    return response.data;
  }

  async createUserDistributionCenter(payload) {
    const url = `${this.url}/api/distribution-center/v1/distribution-centers/user`;
    const response = await api.post(url, payload);
    return response.data;
  }

  async updateUserDistributionCenter(payload) {
    const url = `${this.url}/api/distribution-center/v1/distribution-centers/user`;
    const response = await api.put(url, payload);
    return response.data;
  }
}

export default new DistributionCenterService();
